export const globalGetters = {
  cities: 'city/cities'
}

export const getters = {
  cities: state => state.cities
}
